import api from '../../config/axiosConfig';

const DeleteSearchService = async (id: string) => {
   const response = await api.delete(`/FipeHistory/${id}`);
   return response;
};

export default DeleteSearchService;
